/**
 * Database contract — column sets and constants.
 * Use these in Supabase .select() to avoid drift from schema.
 *
 * Source: supabase/migrations/*.sql
 */

/** Columns for decks table selects (full schema after migrations). */
export const DECK_SELECT_COLUMNS =
  "id, user_id, title, lang, emoji, level, deck_type, type, share_token, share_access, study_modes, created_at";

/** Minimal decks columns — guaranteed by base schema (supabase-schema.sql).
 * Use when DECK_SELECT_COLUMNS fails (missing type/share_access/study_modes). */
export const DECK_SELECT_COLUMNS_SAFE =
  "id, user_id, title, lang, emoji, level, deck_type, share_token, created_at";

/** @deprecated Use DECK_SELECT_COLUMNS */
export const DECKS_SELECT_COLUMNS = DECK_SELECT_COLUMNS;

/** Columns for deck_summaries view (library read-model).
 * Matches view definition in 20260310160000_deck_summaries_and_indexes.sql.
 * Omit emoji in select if view predates it — mapper uses default "📚" when missing. */
export const DECK_SUMMARY_SELECT =
  "deck_id, owner_id, title, description, source_language, target_language, level, deck_type, type, share_token, share_access, study_modes, cards_count, learnable_count, testable_count, games_count, is_public, updated_at, created_at";

/** Minimal deck_summaries columns — core fields that exist in the view.
 * Includes share_token, share_access so share link status is never lost on fallback. */
export const DECK_SUMMARY_SELECT_SAFE =
  "deck_id, owner_id, title, source_language, target_language, level, share_token, share_access, cards_count, learnable_count, testable_count, games_count, is_public, updated_at, created_at";
